import { useState } from 'react';
import { updatePlantillaCobranza } from '../../helpers/api_helper';

const useUpdatePlantilla = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const updatePlantilla = async (id, data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await updatePlantillaCobranza(id, data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to update plantilla: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { updatePlantilla, loading, error };
};

export default useUpdatePlantilla;